export default "__VITE_ASSET__9aac5e95__"